var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.821375
    },
    d: "M 37.083984 16.070312 C 33.346382 16.070312 30.337891 20.530313 30.337891 26.070312 L 30.337891 93.779297 C 30.337891 99.319297 33.346382 103.7793 37.083984 103.7793 L 82.765625 103.7793 C 86.503228 103.7793 89.511719 99.319297 89.511719 93.779297 L 89.511719 32.441406 L 73.142578 16.070312 L 37.083984 16.070312 z M 41.451172 24.455078 L 70.615234 24.455078 L 83.855469 37.695312 L 83.855469 87.306641 C 83.855469 91.787428 81.421438 95.394531 78.398438 95.394531 L 41.451172 95.394531 C 38.428178 95.394531 35.994141 91.787428 35.994141 87.306641 L 35.994141 32.542969 C 35.994141 28.062183 38.428178 24.455078 41.451172 24.455078 z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.767399
    },
    id: "rect4",
    d: "M44.5104 40.7779h30.8241s4.5524 0 4.5524 5.7673v0s0 5.7673 -4.5524 5.7673h-30.8241s-4.5524 0 -4.5524 -5.7673v0s0 -5.7673 4.5524 -5.7673"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.767399
    },
    id: "rect4-2-2",
    d: "M44.5038 58.3034h30.8241s4.5524 0 4.5524 5.7673v0s0 5.7673 -4.5524 5.7673h-30.8241s-4.5524 0 -4.5524 -5.7673v0s0 -5.7673 4.5524 -5.7673"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.767399
    },
    id: "rect4-6-9",
    d: "M44.5003 75.3133h30.8241s4.5524 0 4.5524 5.7673v0s0 5.7673 -4.5524 5.7673h-30.8241s-4.5524 0 -4.5524 -5.7673v0s0 -5.7673 4.5524 -5.7673"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.b7d55a3b.svg";
export { ForwardRef as ReactComponent };